import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { PanelTitle, PeopleList } from 'ui';

import { getRecentUsersAction } from 'store/recentUsers/recentUsersActions';

export const HomeMyOrganisation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, isPending } = useSelector(state => state.recentUsers);

  useEffect(() => {
    dispatch(getRecentUsersAction);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PanelTitle>{t('My organisation')}</PanelTitle>
      <PeopleList data={data} loading={isPending} />
    </>
  );
};
